document.addEventListener('DOMContentLoaded', () => {
  const btn = document.querySelector('.product-form__submit');
  if (!btn) return;
  setInterval(() => {
    btn.classList.add('atc-pulse');
    setTimeout(() => btn.classList.remove('atc-pulse'), 600);
  }, 6000); // cada 6 segundos
});
